// extracted by mini-css-extract-plugin
module.exports = {"wrap":"QuoteElement_wrap__GOAit"};